import { render } from "./SupportCategoriesCard.vue?vue&type=template&id=b3a40bda&ts=true"
import script from "./SupportCategoriesCard.vue?vue&type=script&lang=ts"
export * from "./SupportCategoriesCard.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__